import axios from 'axios'

export default (id) => {
    console.log('masuk getHouseDetails ------====-----====--->', id)
    return (dispatch) => {
        axios.get(`https://www.potterapi.com/v1/characters/${id}?key=$2a$10$ZDF7yaUXPhkdZHoIeg26H.phHi7ALfk7kfxFkUOoy8NROl1oMUPgi`)
        .then(({data})=>{
            dispatch({ type : 'GET_PERSON_DETAIL', person : data})
        })
    }
}